export default {
  data() {
    return {
      special: false,
      isLock: false
    }
  },
  computed: {
    viewable() {
      if (this.special && this.isLock) {
        return false
      }
      return true
    }
  }
}